import styled from 'styled-components'

import Theme from '@theme'

export const Root = styled.div`
  border-top: 1px solid ${Theme.grey300Color};
  padding-left: 2.5rem;
  padding-right: 2.5rem;
`
